module.exports = __webpack_public_path__ + "files/460a9cf4c01ee793d43a8266261bd620.png";